<!-- Begin site response management data display. -->
    <ng-container *ngIf="this.SiteResponseManagementData !== null">
        <h1>Response Management</h1>

        <h4>Site Metrics</h4>

        <div class="site-response-management-metrics-div">
            <!--<p>Under construction:  site Metrics will go here.</p>-->
            <div *ngFor="let strMetricFieldName of this.MetricFieldNames; let i=index"
                 [ngClass]="(i === 0) ? 'first-site-metric-div' : 'secondary-site-metric-div'">
                <p class="site-metric-value-p">{{this.MetricValue(strMetricFieldName)}}</p>

                <p class="site-metric-title-p">{{this.MetricName(strMetricFieldName)}}</p>
            </div>
        </div>

        <br/>

        <h4>Submissions for Review</h4>

        <div class="site-response-management-submissions-for-review-div">
            <!--<p>Under construction:  site submissions for review will go here.</p>-->

            <mat-table [dataSource]="this.SubmissionsDataSource"
                       class="mat-elevation-z4 submissions-mat-table">
                <!-- Define column definitions. -->
                <!--class="submission-id-mat-header-cell"-->
                <ng-container matColumnDef="Submission Id">
                    <mat-header-cell *matHeaderCellDef>
                        Submission Id
                    </mat-header-cell>

                    <mat-cell *matCellDef="let hshSubmissionInfo; let i=index">
                        {{hshSubmissionInfo.submissionId}}
                    </mat-cell>
                </ng-container>

                <!--class="submission-user-mat-header-cell"-->
                <ng-container matColumnDef="Submission User">
                    <mat-header-cell *matHeaderCellDef>
                        Submission User Id
                    </mat-header-cell>

                    <mat-cell *matCellDef="let hshSubmissionInfo; let i=index">
                        {{hshSubmissionInfo.submissionUserId}}
                    </mat-cell>
                </ng-container>

                <!--class="submission-date-mat-header-cell"-->
                <ng-container matColumnDef="Submission Date">
                    <mat-header-cell *matHeaderCellDef>
                        Submission Date
                    </mat-header-cell>

                    <mat-cell *matCellDef="let hshSubmissionInfo">
                        {{hshSubmissionInfo.submissionDate}}
                    </mat-cell>
                </ng-container>

                <!-- Define the table's content, using the above column definitions. -->
                <!--class="submissions-mat-header-row"-->
                <mat-header-row *matHeaderRowDef="this.SubmissionsTableColumnNames">
                </mat-header-row>

                <!--class="submissions-mat-row"-->
                <mat-row *matRowDef="let row; columns: this.SubmissionsTableColumnNames">
                </mat-row>
            </mat-table>
        </div>
    </ng-container>

<!-- Begin temporary form instance testing code (will be removed when the production form instance test page is working). -->
<div *ngIf="this.testFormInstance !== null">
    <!-- Define a form filler/instance component. -->
    <app-form-filler [formInstance]="this.testFormInstance"></app-form-filler>
    <!-- Short text test components. -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField1"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement1"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <br />
    <br />
        -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField2"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement2"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <app-form-field-wrapper [formField]="this.testFormField3"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement3"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <app-form-field-wrapper [formField]="this.testFormField4"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement4"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField5"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement5"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <app-form-field-wrapper [formField]="this.testFormField6"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement6"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField7"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement7"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <app-form-field-wrapper [formField]="this.testFormField8"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement8"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!-- Date test components. -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField9"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement9"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <app-form-field-wrapper [formField]="this.testFormField10"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement10"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!-- Currency test components. -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField11"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement11"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
    <app-form-field-wrapper [formField]="this.testFormField12"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement12"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!-- Drop-down test components. -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField13"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement13"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField14"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement14"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!-- Radio button test components. -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField15"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement15"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
    <!--
    <app-form-field-wrapper [formField]="this.testFormField16"
                            [mode]="'preview'"
                            [(ngModel)]="this.FormInstanceElement16"
                            (ngModelChange)="this.handleNgOnChange()">
    </app-form-field-wrapper>
        -->
</div>
